import * as React from 'react';
import './ResultPage.css';

interface Props {
  title: string;
  message: string;
  success?: boolean;
}

class ResultPageCardComponent extends React.PureComponent<Props> {

  render(): React.ReactNode {
    return (
      <section className="success-page">
          <div className="row">
            <div className="col-lg-10 col-lg-offset-1 text-center">
              <div className="simple-card">
                <div className="gap-20"/>
                {this.props.success === undefined || this.props.success ?
                  <span className="corrected-circle"/>
                  :
                  <span className="alerted-circle"/>
                }
                <div className="gap-20"/>
                <p>
                  <strong>
                    {this.props.title}
                  </strong>
                </p>
                <p>
                  {this.props.message}
                </p>
                <div className="gap-20"/>
              </div>
            </div>
          </div>
      </section>

    );
  }
}

export default ResultPageCardComponent;


// WEBPACK FOOTER //
// ./src/modules/commons/result-page/ResultPageCard.Component.tsx